<template>
  <!-- Breadcrumb -->
  <div class="mt-4 px-4 container-fluid">
    <div class="breadcrumb text-md px-0 mb-4">
      <p>
        <span class="breadcrumb-item" @click="irInicio">Inicio</span> > Analytics Participantes
      </p>
    </div>
  </div>

  <div class="px-4 container-fluid">
    <!-- Buscador / filtros -->
    <div class="row mb-2">
      <div class="col-12">
        <div class="seccion-chip">
          <i class="fas fa-chart-bar" style="font-size:10px"></i>
          Por canal
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <div class="card ficha-buscador">
          <div class="titulo">
            <h5 class="mx-4 mt-5 mb-3">Analytics Participantes</h5>
            <p class="mx-4 mb-4 text-sm opacity-7">
              Listado de participantes por canal (estado, reingresos, tiempo en canal, compras y gasto).
            </p>
          </div>

          <div class="filter-grid px-4 pb-4">
            <!-- Fila 1: inputs -->
            <div class="filter-inputs">
              <div class="filter-field">
                <label class="text-sm mb-1">Tipster</label>
                <div class="select-wrap">
                  <select class="form-select" v-model="filters.tipster_id">
                    <option :value="0">-- Todos --</option>
                    <option v-for="t in tipsters" :key="t.id" :value="Number(t.id)">{{ t.nombre }}</option>
                  </select>
                </div>
              </div>

              <div class="filter-field">
                <label class="text-sm mb-1">Canal</label>
                <div class="select-wrap">
                  <select class="form-select" v-model="filters.canal_id">
                    <option :value="0">-- Todos --</option>
                    <option v-for="c in canalesFiltrados" :key="c.id" :value="Number(c.id)">{{ c.nombre }}</option>
                  </select>
                </div>
              </div>

              <div class="filter-field filter-field--wide">
                <label class="text-sm mb-1">Buscar</label>
                <input class="form-control" v-model="filters.search" placeholder="Nombre o Telegram ID..." @keyup.enter="cargar()" />
              </div>

              <div class="filter-field filter-field--date">
                <label class="text-sm mb-1">Desde</label>
                <input class="form-control" type="date" v-model="filters.desde" />
              </div>

              <div class="filter-field filter-field--date">
                <label class="text-sm mb-1">Hasta</label>
                <input class="form-control" type="date" v-model="filters.hasta" />
              </div>
            </div>

            <!-- Fila 2: checks izquierda · botones derecha -->
            <div class="filter-bottom">
              <div class="filter-checks">
                <label class="filter-check-item">
                  <input type="checkbox" v-model="filters.solo_activos" :true-value="1" :false-value="0" />
                  <span>Solo activos</span>
                </label>
                <label class="filter-check-item">
                  <input type="checkbox" v-model="filters.solo_dados_de_baja" :true-value="1" :false-value="0" />
                  <span>Solo dados de baja</span>
                </label>
                <label class="filter-check-item">
                  <input type="checkbox" v-model="filters.solo_con_compras" :true-value="1" :false-value="0" />
                  <span>Solo con compras</span>
                </label>
                <label class="filter-check-item">
                  <input type="checkbox" v-model="filters.solo_con_reingresos" :true-value="1" :false-value="0" />
                  <span>Solo con reingresos</span>
                </label>
              </div>
              <div class="filter-actions">
                <button class="btn-f-limpiar" :disabled="loading" @click="limpiar()">Limpiar</button>
                <button class="btn-f-buscar" :disabled="loading" @click="cargar()">
                  {{ loading ? "Cargando..." : "Buscar" }}
                </button>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>

    <!-- Resumen -->
    <div class="row mt-4">
      <div class="col-12">
        <div class="card ficha-listado">
          <div class="px-4 pb-4 card-body">
            <div class="d-flex align-items-center justify-content-between flex-wrap gap-2 mb-3">
              <div>
                <h6 class="mb-0">Resumen</h6>
                <p class="text-sm mb-0 opacity-7">
                  Total: <b>{{ total }}</b> · Página <b>{{ page }}</b> / <b>{{ totalPages }}</b>
                </p>
              </div>
            </div>

            <div class="row g-3">
              <div class="col-6 col-lg">
                <div class="mini-card">
                  <div class="k">Total registros</div>
                  <div class="v">{{ total }}</div>
                </div>
              </div>

              <div class="col-6 col-lg">
                <div class="mini-card">
                  <div class="k">Activos</div>
                  <div class="v mini-card__v--verde">{{ totales.activos }}</div>
                  <div class="mini-card__sub" v-if="total > 0">{{ pctActivos }}% del total</div>
                </div>
              </div>

              <div class="col-6 col-lg">
                <div class="mini-card">
                  <div class="k">Con compras</div>
                  <div class="v mini-card__v--azul">{{ totales.con_compras }}</div>
                  <div class="mini-card__sub" v-if="total > 0">{{ pctConCompras }}% del total</div>
                </div>
              </div>

              <div class="col-6 col-lg">
                <div class="mini-card">
                  <div class="k">Gasto total</div>
                  <div class="v">{{ formatMoney(totales.gasto_total) }}</div>
                  <div class="mini-card__sub" v-if="totales.con_compras > 0">{{ formatMoney(totales.gasto_total / totales.con_compras) }} / comprador</div>
                </div>
              </div>

              <div class="col-6 col-lg">
                <div class="mini-card">
                  <div class="k">Reingresos totales</div>
                  <div class="v">{{ totales.reingresos_total }}</div>
                  <div class="mini-card__sub" v-if="total > 0">{{ pctConReingresos }}% con reingresos</div>
                </div>
              </div>
            </div>

            <div v-if="!loading && rows.length === 0" class="mt-4 alert alert-secondary text-sm">
              No hay datos para mostrar con esos filtros.
            </div>

          </div>
        </div>
      </div>
    </div>

    <!-- Gráficos Sección 1 -->
    <div class="row mt-4" v-if="total > 0 && (distribucion.por_franja.length || distribucion.por_idioma.length)">
      <div class="col-12">
        <div class="card ficha-listado">
          <div class="px-4 pb-4 card-body">
            <div class="graficos-row">

              <!-- Donut: estado -->
              <div class="grafico-bloque grafico-bloque--donut">
                <div class="grafico-titulo">Estado</div>
                <div class="grafico-donut-inner">
                  <QuantyDonutChart
                    :labels="['Activos', 'Dados de baja']"
                    :values="donutEstadoValues"
                    :colors="['#43a047', '#546e7a']"
                    :size="160"
                  />
                  <div class="donut-leyenda">
                    <div class="donut-ley-item">
                      <span class="donut-ley-dot" style="background:#43a047"></span>
                      <span>Activos</span>
                      <b>{{ totales.activos }}</b>
                    </div>
                    <div class="donut-ley-item">
                      <span class="donut-ley-dot" style="background:#546e7a"></span>
                      <span>Baja</span>
                      <b>{{ Math.max(0, total - totales.activos) }}</b>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Bar: franjas -->
              <div class="grafico-bloque grafico-bloque--bar" v-if="chartFranjaData.length">
                <QuantyBarChart
                  id="chartFranja"
                  title="Franja horaria"
                  subtitle="Horario de mayor compra"
                  :labels="chartFranjaLabels"
                  :data="chartFranjaData"
                  :horizontal="true"
                  :useFlags="false"
                  tooltipSuffix=" usuarios"
                />
              </div>

              <!-- Lista: idiomas -->
              <div class="grafico-bloque grafico-bloque--bar" v-if="distribucion.por_idioma && distribucion.por_idioma.length">
                <div class="q-chart-card idioma-card">
                  <div class="q-chart-head">
                    <div>
                      <h6 class="mb-0">Idiomas</h6>
                      <p class="text-sm opacity-7 mb-0">Top idiomas de participantes</p>
                    </div>
                  </div>
                  <div class="idioma-lista">
                    <div
                      v-for="r in distribucion.por_idioma.slice(0, 8)"
                      :key="r.idioma"
                      class="idioma-row"
                    >
                      <span class="fi fis idioma-flag-lg" :class="`fi-${langToCountry(r.idioma)}`" :title="langToName(r.idioma)"></span>
                      <span class="idioma-name">{{ langToName(r.idioma) }}</span>
                      <div class="idioma-bar-wrap">
                        <div
                          class="idioma-bar-fill"
                          :style="{ width: (Number(r.total) / distribucion.por_idioma[0].total * 100).toFixed(1) + '%' }"
                        ></div>
                      </div>
                      <span class="idioma-count">{{ r.total }}</span>
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Tabla -->
    <div class="row mt-4" v-if="rows.length">
      <div class="col-12">
        <div class="card ficha-listado mb-4">
          <div class="px-4 pb-4 card-body">

            <div class="d-flex align-items-center justify-content-between flex-wrap gap-2 mb-3">
              <div>
                <h6 class="mb-0">Listado</h6>
                              </div>

              <div class="d-flex align-items-center gap-3">
                <div class="totales-pill">
                  <span>Per page: <b>{{ per_page }}</b></span>
                  <span>Mostrando: <b>{{ rows.length }}</b></span>
                </div>
                <button v-if="canActualizarNicks" class="btn-actualizar-nicks" :disabled="nicksLoading" @click="actualizarNicks()" title="Actualiza nick y nombre de Telegram consultando la API por cada participante del filtro activo">
                  <i v-if="nicksLoading" class="fas fa-spinner fa-spin"></i>
                  <i v-else class="fab fa-telegram"></i>
                  {{ nicksLoading ? 'Iniciando...' : 'Actualizar nicks' }}
                </button>
                <button v-if="canExport" class="btn-excel" :disabled="exportLoading" @click="exportar()">
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/><line x1="8" y1="13" x2="16" y2="13"/><line x1="8" y1="17" x2="16" y2="17"/><polyline points="10 9 9 9 8 9"/></svg>
                  {{ exportLoading ? 'Exportando...' : 'Excel' }}
                </button>
              </div>
            </div>

            <!-- Leyenda badges -->
            <div class="leyenda-badges">
              <span class="leyenda-title">Perfil:</span>
              <span class="perfil-badge perfil-vip">VIP</span><span class="leyenda-desc">Gasto ≥ 100€</span>
              <span class="perfil-badge perfil-reincidente">Reincidente</span><span class="leyenda-desc">2+ reingresos</span>
              <span class="perfil-badge perfil-comprador">Comprador</span><span class="leyenda-desc">Con compras</span>
              <span class="perfil-badge perfil-fugaz">Fugaz</span><span class="leyenda-desc">Salió en &lt;60 min</span>
              <span class="perfil-badge perfil-activo">Activo</span><span class="leyenda-desc">Activo sin otro perfil</span>
            </div>

            <div class="table-responsive">
              <table class="table table-flush table-listado table-empirulada">
                <thead class="thead-light">
                  <tr>
                    <th class="th-sort" @click="sortBy('nombre')">
                      Usuario <span class="sort-icon">{{ sortIcon('nombre') }}</span>
                    </th>
                    <th>Nick Telegram</th>
                    <th>Idioma</th>
                    <th class="th-sort" @click="sortBy('canal')">
                      Canal <span class="sort-icon">{{ sortIcon('canal') }}</span>
                    </th>
                    <th class="text-center th-sort" @click="sortBy('join_primero')">
                      Entrada <span class="sort-icon">{{ sortIcon('join_primero') }}</span>
                    </th>
                    <th class="text-center th-sort" @click="sortBy('estado')">
                      Estado <span class="sort-icon">{{ sortIcon('estado') }}</span>
                    </th>
                    <th class="text-center th-sort" @click="sortBy('minutos')">
                      Min. canal <span class="sort-icon">{{ sortIcon('minutos') }}</span>
                    </th>
                    <th class="text-center th-sort" @click="sortBy('reingresos')">
                      Reing. <span class="sort-icon">{{ sortIcon('reingresos') }}</span>
                    </th>
                    <th class="text-center th-sort" @click="sortBy('compras')">
                      Compras <span class="sort-icon">{{ sortIcon('compras') }}</span>
                    </th>
                    <th class="text-end th-sort" @click="sortBy('gasto')">
                      Gasto <span class="sort-icon">{{ sortIcon('gasto') }}</span>
                    </th>
                    <th class="text-center">Franja top</th>
                    <th style="width:40px"></th>
                  </tr>
                </thead>

                <tbody class="text-sm">
                  <tr v-for="r in rows" :key="`${r.telegram_id}-${r.canal_id}`">
                    <td>
                      <div class="campana-nombre">
                        {{ r.nombre || "-" }}
                        <span v-if="perfilBadge(r)" class="perfil-badge" :class="`perfil-${perfilBadge(r).key}`">{{ perfilBadge(r).label }}</span>
                      </div>
                      <div class="canal-sub">
                        ID: {{ r.telegram_id }}
                        <span v-if="r.campana_nombre">· {{ r.campana_nombre }}</span>
                        <span v-else-if="r.campana_entrada_id && Number(r.campana_entrada_id) !== 0" class="opacity-5">· #{{ r.campana_entrada_id }}</span>
                      </div>
                    </td>

                    <td>
                      <span v-if="r.telegram_username" class="detalle-username">@{{ r.telegram_username }}</span>
                      <span v-else class="celda-vacia">—</span>
                    </td>

                    <td class="text-center">
                      <span
                        class="fi idioma-flag"
                        :class="r.idioma ? `fi-${langToCountry(r.idioma)}` : ''"
                        :title="r.idioma || '—'"
                      ></span>
                    </td>

                    <td>
                      <div class="campana-nombre">{{ r.canal_nombre }}</div>
                      <div class="canal-sub">{{ tipsterMap[r.tipster_id] || `Tipster ${r.tipster_id}` }}</div>
                    </td>

                    <td class="text-center">
                      <span class="fecha-entrada">{{ fmtFecha(r.join_primero) }}</span>
                    </td>

                    <td class="text-center">
                      <span class="estado-pill" :class="r.estado_en_canal === 'ACTIVO' ? 'estado-activo' : 'estado-salio'">
                        <span class="estado-dot"></span>
                        {{ r.estado_en_canal === 'ACTIVO' ? 'Activo' : 'Salió' }}
                      </span>
                    </td>

                    <td class="text-center">{{ formatMinutes(r.minutos_en_canal) }}</td>

                    <td class="text-center">
                      <span v-if="Number(r.reingresos_total) > 0" class="reingreso-badge">{{ r.reingresos_total }}</span>
                      <span v-else class="celda-vacia">—</span>
                    </td>

                    <td class="text-center">
                      <span v-if="Number(r.compras) > 0" class="compras-badge">{{ r.compras }}</span>
                      <span v-else class="celda-vacia">—</span>
                    </td>

                    <td>
                      <div v-if="Number(r.gasto) > 0" class="gasto-bar-row">
                        <div class="gasto-bar-track">
                          <div class="gasto-bar-fill" :style="{ width: gastoRelativo(r.gasto) + '%' }"></div>
                        </div>
                        <span class="gasto-valor">{{ formatMoney(r.gasto) }}</span>
                      </div>
                      <span v-else class="celda-vacia">—</span>
                    </td>

                    <td class="text-center">
                      <span v-if="r.franja_top_es" class="franja-badge" :class="`franja-${r.franja_top_es}`">
                        {{ fmtFranja(r.franja_top_es) }}
                      </span>
                      <span v-else class="celda-vacia">—</span>
                    </td>

                    <td class="text-center">
                      <button class="btn-detalle" @click="abrirDetalle(r)" title="Ver detalle">
                        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg>
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            <!-- Paginación -->
            <div class="pagi-row">
              <button class="btn btn-sm btn-secondary" :disabled="loading || page <= 1" @click="goPage(1)">
                «
              </button>
              <button class="btn btn-sm btn-secondary" :disabled="loading || page <= 1" @click="goPage(page - 1)">
                ‹
              </button>

              <div class="pagi-info text-sm">
                Página <b>{{ page }}</b> de <b>{{ totalPages }}</b>
              </div>

              <button class="btn btn-sm btn-secondary" :disabled="loading || page >= totalPages" @click="goPage(page + 1)">
                ›
              </button>
              <button class="btn btn-sm btn-secondary" :disabled="loading || page >= totalPages" @click="goPage(totalPages)">
                »
              </button>

              <div class="ms-auto d-flex align-items-center gap-2">
                <span class="text-sm opacity-7">Por página</span>
                <div class="select-wrap" style="width:110px">
                  <select class="form-select form-select-sm" v-model="per_page" @change="cargar(true)">
                    <option :value="5">5</option>
                    <option :value="10">10</option>
                    <option :value="25">25</option>
                    <option :value="50">50</option>
                    <option :value="100">100</option>
                  </select>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>

  </div>

  <!-- ========================= SECCIÓN 2: POR USUARIO ========================= -->
  <div class="px-4 container-fluid mt-4">
    <div class="row">
      <div class="col-12">
        <div class="seccion-sep">
          <div class="seccion-sep__rail"></div>
          <div class="seccion-sep__label">
            <i class="fas fa-users" style="font-size:10px"></i>
            Participantes por usuario
          </div>
          <div class="seccion-sep__rail"></div>
        </div>
      </div>
    </div>
  </div>

  <div class="px-4 container-fluid">

    <!-- Filtros sección 2 -->
    <div class="row mb-2">
      <div class="col-12">
        <div class="seccion-chip" style="color:#9575cd; border-color:rgba(149,117,205,.3);">
          <i class="fas fa-users" style="font-size:10px"></i>
          Por usuario
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <div class="card ficha-buscador">
          <div class="filter-grid px-4 pt-4 pb-4">
            <div class="filter-inputs">
              <div class="filter-field">
                <label class="text-sm mb-1">Tipster</label>
                <div class="select-wrap">
                  <select class="form-select" v-model="u_filters.tipster_id">
                    <option :value="0">-- Todos --</option>
                    <option v-for="t in tipsters" :key="t.id" :value="Number(t.id)">{{ t.nombre }}</option>
                  </select>
                </div>
              </div>
              <div class="filter-field filter-field--wide">
                <label class="text-sm mb-1">Buscar</label>
                <input class="form-control" v-model="u_filters.search" placeholder="Nombre o Telegram ID..." @keyup.enter="u_cargar()" />
              </div>
            </div>
            <div class="filter-bottom">
              <div class="filter-checks">
                <label class="filter-check-item">
                  <input type="checkbox" v-model="u_filters.solo_activos" :true-value="1" :false-value="0" />
                  <span>Solo activos</span>
                </label>
                <label class="filter-check-item">
                  <input type="checkbox" v-model="u_filters.solo_con_compras" :true-value="1" :false-value="0" />
                  <span>Solo con compras</span>
                </label>
              </div>
              <div class="filter-actions">
                <button class="btn-f-limpiar" :disabled="u_loading" @click="u_limpiar()">Limpiar</button>
                <button class="btn-f-buscar" :disabled="u_loading" @click="u_cargar()">
                  {{ u_loading ? 'Cargando...' : 'Buscar' }}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Tabla sección 2 -->
    <div class="row mt-4" v-if="u_rows.length || u_loading">
      <div class="col-12">
        <div class="card ficha-listado mb-4">
          <div class="px-4 pb-4 card-body">

            <div class="d-flex align-items-center justify-content-between flex-wrap gap-2 mb-3">
              <div>
                <h6 class="mb-0">Usuarios únicos</h6>
                <p class="text-sm mb-0 opacity-7">Total: <b>{{ u_total }}</b> · Página <b>{{ u_page }}</b> / <b>{{ u_totalPages }}</b></p>
              </div>
              <div class="d-flex align-items-center gap-3">
                <button v-if="canActualizarNicks" class="btn-actualizar-nicks" :disabled="u_nicksLoading" @click="u_actualizarNicks()" title="Actualiza nick y nombre de Telegram para todos los participantes únicos del filtro activo">
                  <i v-if="u_nicksLoading" class="fas fa-spinner fa-spin"></i>
                  <i v-else class="fab fa-telegram"></i>
                  {{ u_nicksLoading ? 'Iniciando...' : 'Actualizar nicks' }}
                </button>
                <button v-if="canExport" class="btn-excel" :disabled="u_exportLoading" @click="u_exportar()">
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/><line x1="8" y1="13" x2="16" y2="13"/><line x1="8" y1="17" x2="16" y2="17"/><polyline points="10 9 9 9 8 9"/></svg>
                  {{ u_exportLoading ? 'Exportando...' : 'Excel' }}
                </button>
              </div>
            </div>

            <!-- Mini-cards sección 2 -->
            <div v-if="!u_loading || u_totales.total_usuarios > 0" class="row g-3 mb-4">
              <div class="col-6 col-lg">
                <div class="mini-card">
                  <div class="k">Usuarios únicos</div>
                  <div class="v">{{ u_totales.total_usuarios }}</div>
                </div>
              </div>
              <div class="col-6 col-lg">
                <div class="mini-card">
                  <div class="k">Activos</div>
                  <div class="v mini-card__v--verde">{{ u_totales.total_activos }}</div>
                  <div class="mini-card__sub" v-if="u_totales.total_usuarios > 0">{{ Math.round(u_totales.total_activos / u_totales.total_usuarios * 100) }}% del total</div>
                </div>
              </div>
              <div class="col-6 col-lg">
                <div class="mini-card">
                  <div class="k">Multicanal</div>
                  <div class="v mini-card__v--azul">{{ u_totales.total_multicanal }}</div>
                  <div class="mini-card__sub">En 2+ canales</div>
                </div>
              </div>
              <div class="col-6 col-lg">
                <div class="mini-card">
                  <div class="k">Compradores</div>
                  <div class="v mini-card__v--verde">{{ u_totales.total_con_compras }}</div>
                  <div class="mini-card__sub" v-if="u_totales.total_usuarios > 0">{{ Math.round(u_totales.total_con_compras / u_totales.total_usuarios * 100) }}% del total</div>
                </div>
              </div>
              <div class="col-6 col-lg">
                <div class="mini-card">
                  <div class="k">Gasto total</div>
                  <div class="v">{{ formatMoney(u_totales.gasto_total) }}</div>
                  <div class="mini-card__sub" v-if="u_totales.total_con_compras > 0">{{ formatMoney(u_totales.gasto_total / u_totales.total_con_compras) }} / comprador</div>
                </div>
              </div>
            </div>

            <div v-if="u_loading" class="text-center py-4 opacity-7 text-sm">Cargando...</div>
            <div v-else-if="u_rows.length === 0" class="text-center py-4 opacity-7 text-sm">Sin resultados</div>

            <div v-else class="table-responsive">
              <table class="table table-flush table-listado table-empirulada">
                <thead class="thead-light">
                  <tr>
                    <th @click="u_sortBy('nombre')" class="th-sort">Usuario <span class="sort-icon">{{ u_sortIcon('nombre') }}</span></th>
                    <th>Nick Telegram</th>
                    <th>Idioma</th>
                    <th class="text-center" @click="u_sortBy('total_canales')" style="cursor:pointer">Canales <span class="sort-icon">{{ u_sortIcon('total_canales') }}</span></th>
                    <th class="text-center" @click="u_sortBy('compras')" style="cursor:pointer">Compras <span class="sort-icon">{{ u_sortIcon('compras') }}</span></th>
                    <th class="text-end"    @click="u_sortBy('gasto')" style="cursor:pointer">Gasto <span class="sort-icon">{{ u_sortIcon('gasto') }}</span></th>
                  </tr>
                </thead>
                <tbody class="text-sm">
                  <tr v-for="r in u_rows" :key="r.telegram_id">
                    <td>
                      <div class="campana-nombre">{{ r.nombre || '—' }}</div>
                      <div class="canal-sub">ID: {{ r.telegram_id }}</div>
                    </td>
                    <td>
                      <span v-if="r.telegram_username" class="detalle-username">@{{ r.telegram_username }}</span>
                      <span v-else class="celda-vacia">—</span>
                    </td>
                    <td class="text-center">
                      <span class="fi idioma-flag" :class="r.idioma ? `fi-${langToCountry(r.idioma)}` : ''" :title="r.idioma || '—'"></span>
                    </td>
                    <td class="text-center">
                      <div class="d-flex align-items-center justify-content-center gap-2">
                        <span class="canal-count-badge">{{ r.total_canales }}</span>
                        <span v-if="Number(r.total_canales) >= 2" class="multicanal-tag">multi</span>
                        <span v-else-if="Number(r.canales_activos) > 0" class="text-xs opacity-7">({{ r.canales_activos }}✓)</span>
                        <button class="btn-detalle" @click="u_abrirCanales(r)" title="Ver canales">
                          <i class="fas fa-eye" style="font-size:12px"></i>
                        </button>
                      </div>
                    </td>
                    <td class="text-center">
                      <span v-if="Number(r.compras) > 0" class="compras-badge">{{ r.compras }}</span>
                      <span v-else class="celda-vacia">—</span>
                    </td>
                    <td class="text-end">
                      <span v-if="Number(r.gasto) > 0">{{ formatMoney(r.gasto) }}</span>
                      <span v-else class="celda-vacia">—</span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            <!-- Paginación sección 2 -->
            <div class="pagi-row" v-if="u_rows.length">
              <button class="btn btn-sm btn-secondary" :disabled="u_loading || u_page <= 1" @click="u_goPage(1)">«</button>
              <button class="btn btn-sm btn-secondary" :disabled="u_loading || u_page <= 1" @click="u_goPage(u_page - 1)">‹</button>
              <div class="pagi-info text-sm">Página <b>{{ u_page }}</b> de <b>{{ u_totalPages }}</b></div>
              <button class="btn btn-sm btn-secondary" :disabled="u_loading || u_page >= u_totalPages" @click="u_goPage(u_page + 1)">›</button>
              <button class="btn btn-sm btn-secondary" :disabled="u_loading || u_page >= u_totalPages" @click="u_goPage(u_totalPages)">»</button>
              <div class="ms-auto d-flex align-items-center gap-2">
                <span class="text-sm opacity-7">Por página</span>
                <div class="select-wrap" style="width:110px">
                  <select class="form-select form-select-sm" v-model="u_per_page" @change="u_cargar(true)">
                    <option :value="10">10</option>
                    <option :value="25">25</option>
                    <option :value="50">50</option>
                    <option :value="100">100</option>
                  </select>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>

    <!-- Gráfico Sección 2: distribución por canales -->
    <div class="row mt-4" v-if="chartCanalesData.length">
      <div class="col-12 col-lg-7">
        <QuantyBarChart
          id="chartCanales"
          title="Usuarios por número de canales"
          subtitle="Cuántos canales tiene cada usuario"
          :labels="chartCanalesLabels"
          :data="chartCanalesData"
          :horizontal="false"
          :useFlags="false"
          :integerTicks="true"
          :maxBarSize="56"
          tooltipSuffix=" usuarios"
        />
      </div>
    </div>

  </div>

  <!-- ========================= MODAL CANALES USUARIO ========================= -->
  <teleport to="body">
    <transition name="modal-fade">
      <div v-if="u_modal.open" class="det-overlay" @click.self="u_modal.open = false">
        <div class="det-panel">
          <div class="det-header">
            <div>
              <div class="det-nombre">{{ u_modal.nombre || '—' }}</div>
              <div class="det-sub">
                ID: {{ u_modal.telegram_id }}
                <span v-if="u_modal.telegram_username" class="detalle-username ms-2">@{{ u_modal.telegram_username }}</span>
              </div>
            </div>
            <button class="det-close" @click="u_modal.open = false">✕</button>
          </div>
          <div v-if="u_modal.loading" class="det-loading">
            <span class="det-spinner"></span> Cargando...
          </div>
          <div v-else class="det-body">
            <div class="det-section">
              <div class="det-section-title">Canales <span class="det-badge">{{ u_modal.canales.length }}</span></div>
              <div v-if="!u_modal.canales.length" class="det-empty">Sin canales registrados</div>
              <table v-else class="det-table">
                <thead>
                  <tr>
                    <th>Canal</th>
                    <th>Tipster</th>
                    <th class="text-center">Estado</th>
                    <th class="text-center">1ª entrada</th>
                    <th class="text-center">Última salida</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="c in u_modal.canales" :key="c.canal_id">
                    <td class="fw-bold">{{ c.canal_nombre }}</td>
                    <td class="text-sm opacity-7">{{ tipsterMap[c.tipster_id] || `Tipster ${c.tipster_id}` }}</td>
                    <td class="text-center">
                      <span class="estado-pill" :class="c.activo_cnt > 0 ? 'estado-activo' : 'estado-salio'">
                        <span class="estado-dot"></span>
                        {{ c.activo_cnt > 0 ? 'Activo' : 'Salió' }}
                      </span>
                    </td>
                    <td class="text-center">{{ fmtFecha(c.join_primero) }}</td>
                    <td class="text-center">{{ c.activo_cnt > 0 ? '—' : fmtFecha(c.leave_ultimo) }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </teleport>

  <!-- ========================= MODAL DETALLE ========================= -->
  <teleport to="body">
    <transition name="modal-fade">
      <div v-if="modal.open" class="det-overlay" @click.self="cerrarDetalle">
        <div class="det-panel">

          <!-- Header -->
          <div class="det-header">
            <div>
              <div class="det-nombre">{{ modal.nombre || '—' }}</div>
              <div class="det-sub">Telegram ID: {{ modal.telegram_id }}</div>
            </div>
            <button class="det-close" @click="cerrarDetalle">✕</button>
          </div>

          <!-- Loading -->
          <div v-if="modal.loading" class="det-loading">
            <span class="det-spinner"></span> Cargando...
          </div>

          <!-- Contenido -->
          <div v-else class="det-body">

            <!-- Canales -->
            <div class="det-section">
              <div class="det-section-title">Canales</div>
              <div v-if="!modal.canales.length" class="det-empty">Sin registros de canal</div>
              <table v-else class="det-table">
                <thead>
                  <tr>
                    <th>Canal</th>
                    <th class="text-center">Estado</th>
                    <th class="text-center">1ª entrada</th>
                    <th class="text-center">Última salida</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="c in modal.canales" :key="c.canal_id">
                    <td class="fw-bold">{{ c.canal_nombre }}</td>
                    <td class="text-center">
                      <span class="estado-pill" :class="c.activo_cnt > 0 ? 'estado-activo' : 'estado-salio'">
                        <span class="estado-dot"></span>
                        {{ c.activo_cnt > 0 ? 'Activo' : 'Salió' }}
                      </span>
                    </td>
                    <td class="text-center">{{ fmtFecha(c.join_primero) }}</td>
                    <td class="text-center">{{ c.activo_cnt > 0 ? '—' : fmtFecha(c.leave_ultimo) }}</td>
                  </tr>
                </tbody>
              </table>
            </div>

            <!-- Timeline compras -->
            <div class="det-section">
              <div class="det-section-title">Compras <span class="det-badge">{{ modal.compras.length }}</span></div>
              <div v-if="!modal.compras.length" class="det-empty">Sin compras registradas</div>
              <div v-else class="det-timeline">
                <div v-for="(p, i) in modal.compras" :key="p.id" class="det-tl-item">
                  <div class="det-tl-dot"></div>
                  <div v-if="i < modal.compras.length - 1" class="det-tl-line"></div>
                  <div class="det-tl-content">
                    <div class="det-tl-fecha">{{ fmtFechaHora(p.created_at_es || p.created_at) }}</div>
                    <div class="det-tl-info">
                      <span class="det-tl-canal">{{ canalNombre(p.canal_id) }}</span>
                      <span class="det-tl-precio">{{ formatMoney(p.precio) }}</span>
                      <span class="det-tl-tipo">{{ p.tipo_compra }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </transition>
  </teleport>

</template>

<script>
import showSwal from "@/mixins/showSwal.js";
import { globalFunctionsMixin } from "@/mixins/globalFunctions.js";
import QuantyDonutChart from "@/components/charts/QuantyDonutChart.vue";
import QuantyBarChart   from "@/components/charts/QuantyBarChart.vue";

// ✅ si prefieres service axios, lo enchufas aquí
// import { fetchParticipantes, exportParticipantes } from "@/services/analyticsParticipantes";

export default {
  name: "AnalyticsParticipantes",
  mixins: [globalFunctionsMixin],
  components: { QuantyDonutChart, QuantyBarChart },
  data() {
    return {
      loading: false,
      exportLoading: false,
      nicksLoading: false,

      modal: {
        open: false,
        loading: false,
        telegram_id: null,
        nombre: '',
        canales: [],
        compras: [],
      },

      // combos (los puedes cargar desde endpoints si ya existen)
      tipsters: [],
      canales: [],

      // listado
      rows: [],
      total: 0,
      totales: { activos: 0, con_compras: 0, gasto_total: 0, reingresos_total: 0, con_reingresos: 0 },
      distribucion: { por_franja: [], por_idioma: [] },
      page: 1,
      per_page: 10,
      order_by: "gasto",
      order_dir: "DESC",

      filters: {
        tipster_id: 0,
        canal_id: 0,
        solo_activos: 0,
        solo_dados_de_baja: 0,
        solo_con_compras: 0,
        solo_con_reingresos: 0,
        search: "",
        desde: null,
        hasta: null,
      },

      // Sección 2 — por usuario
      u_loading: false,
      u_rows: [],
      u_total: 0,
      u_page: 1,
      u_per_page: 25,
      u_order_by: 'gasto',
      u_order_dir: 'DESC',
      u_filters: {
        tipster_id: 0,
        solo_activos: 0,
        solo_con_compras: 0,
        search: '',
      },
      u_totales: {
        total_usuarios: 0,
        total_activos: 0,
        total_multicanal: 0,
        total_con_compras: 0,
        gasto_total: 0,
      },
      u_distribucion: { por_canales: [] },
      u_exportLoading: false,
      u_nicksLoading: false,
      u_modal: {
        open: false,
        loading: false,
        telegram_id: null,
        telegram_username: null,
        nombre: '',
        canales: [],
      },
    };
  },
  computed: {
    permisos() {
      return this.$store.state.auth?.permisos_finales || [];
    },
    canExport() {
      return Array.isArray(this.permisos) && this.permisos.includes("analytics.participantes.exportar");
    },
    canActualizarNicks() {
      const rol = this.$store.getters['auth/rolEfectivo'];
      return [1, 2].includes(rol);
    },

    totalPages() {
      const t = Number(this.total || 0);
      const pp = Number(this.per_page || 10);
      return Math.max(1, Math.ceil(t / pp));
    },
    canalesFiltrados() {
      if (!this.filters.tipster_id) return this.canales;
      return this.canales.filter(c => Number(c.tipster_id) === Number(this.filters.tipster_id));
    },

    tipsterMap() {
      const m = {};
      for (const t of this.tipsters) m[Number(t.id)] = t.nombre;
      return m;
    },
    sortIcon() {
      return (col) => {
        if (this.order_by !== col) return "▼▲";
        return this.order_dir === "DESC" ? "▼" : "▲";
      };
    },
    pctActivos() {
      return this.total > 0 ? ((this.totales.activos / this.total) * 100).toFixed(1) : "0.0";
    },
    pctConCompras() {
      return this.total > 0 ? ((this.totales.con_compras / this.total) * 100).toFixed(1) : "0.0";
    },
    pctConReingresos() {
      return this.total > 0 ? ((this.totales.con_reingresos / this.total) * 100).toFixed(1) : "0.0";
    },
    maxGasto() {
      return Math.max(...this.rows.map(r => Number(r.gasto || 0)), 1);
    },

    // Sección 2
    u_totalPages() {
      return Math.max(1, Math.ceil(this.u_total / this.u_per_page));
    },
    u_sortIcon() {
      return (col) => {
        if (this.u_order_by !== col) return '▼▲';
        return this.u_order_dir === 'DESC' ? '▼' : '▲';
      };
    },

    // ===== Charts Sección 1 =====
    donutEstadoValues() {
      const activos = this.totales?.activos || 0;
      const bajas   = Math.max(0, this.total - activos);
      return [activos, bajas];
    },
    chartFranjaLabels() {
      const MAP = { 'mañana': '☀️ Mañana', 'tarde': '🌅 Tarde', 'noche': '🌙 Noche' };
      return (this.distribucion.por_franja || []).map(r => MAP[r.franja] || r.franja);
    },
    chartFranjaData() {
      return (this.distribucion.por_franja || []).map(r => Number(r.total));
    },
    chartIdiomaLabels() {
      return (this.distribucion.por_idioma || []).map(r => this.langToCountry(r.idioma));
    },
    chartIdiomaData() {
      return (this.distribucion.por_idioma || []).map(r => Number(r.total));
    },

    // ===== Charts Sección 2 =====
    chartCanalesLabels() {
      return (this.u_distribucion.por_canales || []).map(r =>
        r.bucket === '1' ? '1 canal' : r.bucket === '4+' ? '4+ canales' : `${r.bucket} canales`
      );
    },
    chartCanalesData() {
      return (this.u_distribucion.por_canales || []).map(r => Number(r.total));
    },
  },
  methods: {
    irInicio() {
      this.$router.push("/dashboard");
    },
    limpiar() {
      this.filters = {
        tipster_id: 0,
        canal_id: 0,
        solo_activos: 0,
        solo_dados_de_baja: 0,
        solo_con_compras: 0,
        solo_con_reingresos: 0,
        search: "",
        desde: null,
        hasta: null,
      };
      this.page = 1;
      this.per_page = 10;
      this.cargar(true);
    },
    langToCountry(code) {
      const MAP = {
        es: 'es', en: 'gb', pt: 'pt', fr: 'fr', de: 'de',
        it: 'it', ca: 'es', ru: 'ru', ar: 'sa', nl: 'nl',
        pl: 'pl', tr: 'tr', ro: 'ro', uk: 'ua', zh: 'cn',
        ja: 'jp', ko: 'kr', sv: 'se', da: 'dk', fi: 'fi',
        nb: 'no', el: 'gr', cs: 'cz', hu: 'hu', bg: 'bg',
      };
      if (!code) return 'un';
      return MAP[code.toLowerCase()] || code.toLowerCase();
    },
    langToName(code) {
      const MAP = {
        es: 'Español', en: 'English', pt: 'Português', fr: 'Français', de: 'Deutsch',
        it: 'Italiano', ca: 'Català', ru: 'Русский', ar: 'العربية', nl: 'Nederlands',
        pl: 'Polski', tr: 'Türkçe', ro: 'Română', uk: 'Українська', zh: '中文',
        ja: '日本語', ko: '한국어', sv: 'Svenska', da: 'Dansk', fi: 'Suomi',
        nb: 'Norsk', el: 'Ελληνικά', cs: 'Čeština', hu: 'Magyar', bg: 'Български',
      };
      if (!code) return '—';
      return MAP[code.toLowerCase()] || code.toUpperCase();
    },
    fmtFranja(f) {
      const MAP = { 'mañana': '☀️ Mañana', 'tarde': '🌅 Tarde', 'noche': '🌙 Noche' };
      return MAP[f] || f;
    },
    fmtFecha(s) {
      if (!s) return "—";
      const d = s.split(" ")[0]; // YYYY-MM-DD
      const [y, m, day] = d.split("-");
      return `${day}/${m}/${y}`;
    },
    formatMoney(n) {
      const num = Number(n || 0);
      return num.toLocaleString("es-ES", { style: "currency", currency: "EUR" });
    },
    formatMinutes(mins) {
      const m = Number(mins || 0);
      if (m < 60) return `${m}m`;
      const h = Math.floor(m / 60);
      const rm = m % 60;
      return `${h}h ${rm}m`;
    },

    async cargar(resetPage = false) {
      if (resetPage) this.page = 1;

      this.loading = true;
      try {
        const payload = {
          ...this.filters,
          page: this.page,
          per_page: this.per_page,
          desde: this.filters.desde || null,
          hasta: this.filters.hasta || null,
          order_by: this.order_by,
          order_dir: this.order_dir,
        };

        const resp = await this.apiFetch(payload);

        // tu API devuelve: { page, per_page, total, data: [...] }
        this.page        = Number(resp.page || this.page);
        this.per_page    = Number(resp.per_page || this.per_page);
        this.total       = Number(resp.total || 0);
        this.totales     = resp.totales     || { activos: 0, con_compras: 0, gasto_total: 0, reingresos_total: 0, con_reingresos: 0 };
        this.distribucion= resp.distribucion|| { por_franja: [], por_idioma: [] };
        this.rows        = Array.isArray(resp.data) ? resp.data : [];

      } catch (e) {
        console.error(e);
        showSwal.methods.showSwal({
          type: "error",
          message: "No se pudo cargar Analytics Participantes",
          width: 520,
        });
        this.rows = [];
        this.total = 0;
      } finally {
        this.loading = false;
      }
    },

    async actualizarNicks() {
      this.nicksLoading = true;
      try {
        const payload = {
          tipster_id: this.filters.tipster_id || 0,
          canal_id:   this.filters.canal_id   || 0,
        };
        await this.$store.dispatch('auth/analyticsActualizarNicks', payload);
        this.$swal?.fire({
          icon: 'info',
          title: 'Proceso iniciado',
          text: 'La actualización de nicks se está ejecutando en segundo plano. Puede tardar varios minutos según el volumen de participantes.',
          timer: 5000,
          showConfirmButton: false,
        });
      } catch {
        this.$swal?.fire({ icon: 'error', title: 'Error', text: 'No se pudo iniciar el proceso.', timer: 3000, showConfirmButton: false });
      } finally {
        this.nicksLoading = false;
      }
    },

    async exportar() {
      this.exportLoading = true;
      try {
        const payload = {
          ...this.filters,
          desde: this.filters.desde || null,
          hasta: this.filters.hasta || null,
        };

        const blob = await this.apiExport(payload);
        const filename = `analytics_participantes_${this.hoyYMD()}.xlsx`;

        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = filename;
        document.body.appendChild(a);
        a.click();
        a.remove();
        window.URL.revokeObjectURL(url);

      } catch (e) {
        console.error(e);
        showSwal.methods.showSwal({
          type: "error",
          message: "No se pudo exportar el Excel",
          width: 520,
        });
      } finally {
        this.exportLoading = false;
      }
    },

    gastoRelativo(gasto) {
      return Math.max((Number(gasto) / this.maxGasto) * 100, 2).toFixed(1);
    },
    perfilBadge(r) {
      const gasto      = Number(r.gasto || 0);
      const compras    = Number(r.compras || 0);
      const reingresos = Number(r.reingresos_total || 0);
      const minutos    = Number(r.minutos_en_canal || 0);
      const activo     = r.estado_en_canal === 'ACTIVO';
      if (gasto >= 100)                          return { key: 'vip',        label: 'VIP' };
      if (reingresos >= 2)                       return { key: 'reincidente', label: 'Reincidente' };
      if (compras > 0)                           return { key: 'comprador',  label: 'Comprador' };
      if (!activo && minutos < 60)               return { key: 'fugaz',      label: 'Fugaz' };
      if (activo)                                return { key: 'activo',     label: 'Activo' };
      return null;
    },

    async abrirDetalle(row) {
      this.modal.open = true;
      this.modal.loading = true;
      this.modal.telegram_id = row.telegram_id;
      this.modal.nombre = row.nombre;
      this.modal.canales = [];
      this.modal.compras = [];
      try {
        const resp = await this.$store.dispatch("auth/analyticsParticipantesDetalle", {
          telegram_id: String(row.telegram_id),
        });
        this.modal.canales = resp.canales || [];
        this.modal.compras = resp.compras || [];
      } catch (e) {
        console.error(e);
      } finally {
        this.modal.loading = false;
      }
    },
    cerrarDetalle() {
      this.modal.open = false;
    },
    fmtFechaHora(s) {
      if (!s) return "—";
      const [fecha, hora] = s.split(" ");
      if (!fecha) return "—";
      const [y, m, d] = fecha.split("-");
      return `${d}/${m}/${y} ${hora ? hora.slice(0, 5) : ''}`;
    },
    canalNombre(canalId) {
      const c = this.canales.find(c => Number(c.id) === Number(canalId));
      return c ? c.nombre : `Canal ${canalId}`;
    },

    sortBy(col) {
      if (this.order_by === col) {
        this.order_dir = this.order_dir === "DESC" ? "ASC" : "DESC";
      } else {
        this.order_by  = col;
        this.order_dir = "DESC";
      }
      this.cargar(true);
    },

    goPage(p) {
      const next = Math.min(this.totalPages, Math.max(1, Number(p)));
      if (next === this.page) return;
      this.page = next;
      this.cargar(false);
    },

    hoyYMD() {
      const d = new Date();
      const y = d.getFullYear();
      const m = String(d.getMonth() + 1).padStart(2, "0");
      const day = String(d.getDate()).padStart(2, "0");
      return `${y}-${m}-${day}`;
    },

    // =========================
    // 🔌 Conexión a API (elige 1)
    // =========================
    // ===========================
    // Sección 2 — por usuario
    // ===========================
    u_limpiar() {
      this.u_filters = { tipster_id: 0, solo_activos: 0, solo_con_compras: 0, search: '' };
      this.u_page = 1;
      this.u_rows = [];
      this.u_total = 0;
      this.u_totales      = { total_usuarios: 0, total_activos: 0, total_multicanal: 0, total_con_compras: 0, gasto_total: 0 };
      this.u_distribucion = { por_canales: [] };
    },
    async u_cargar(resetPage = false) {
      if (resetPage) this.u_page = 1;
      this.u_loading = true;
      try {
        const resp = await this.$store.dispatch('auth/analyticsParticipantesPorUsuario', {
          ...this.u_filters,
          page:      this.u_page,
          per_page:  this.u_per_page,
          order_by:  this.u_order_by,
          order_dir: this.u_order_dir,
        });
        this.u_rows         = Array.isArray(resp.data) ? resp.data : [];
        this.u_total        = Number(resp.total || 0);
        this.u_page         = Number(resp.page || this.u_page);
        this.u_totales      = resp.totales      || { total_usuarios: 0, total_activos: 0, total_multicanal: 0, total_con_compras: 0, gasto_total: 0 };
        this.u_distribucion = resp.distribucion || { por_canales: [] };
      } catch (e) {
        console.error(e);
        this.u_rows = [];
      } finally {
        this.u_loading = false;
      }
    },
    u_sortBy(col) {
      if (this.u_order_by === col) {
        this.u_order_dir = this.u_order_dir === 'DESC' ? 'ASC' : 'DESC';
      } else {
        this.u_order_by  = col;
        this.u_order_dir = 'DESC';
      }
      this.u_cargar(true);
    },
    u_goPage(p) {
      const next = Math.min(this.u_totalPages, Math.max(1, Number(p)));
      if (next === this.u_page) return;
      this.u_page = next;
      this.u_cargar(false);
    },
    async u_actualizarNicks() {
      this.u_nicksLoading = true;
      try {
        await this.$store.dispatch('auth/analyticsActualizarNicks', {
          tipster_id: this.u_filters.tipster_id || 0,
          canal_id:   0,
        });
        this.$swal?.fire({
          icon: 'info',
          title: 'Proceso iniciado',
          text: 'La actualización de nicks se está ejecutando en segundo plano. Puede tardar varios minutos según el volumen de participantes.',
          timer: 5000,
          showConfirmButton: false,
        });
      } catch {
        this.$swal?.fire({ icon: 'error', title: 'Error', text: 'No se pudo iniciar el proceso.', timer: 3000, showConfirmButton: false });
      } finally {
        this.u_nicksLoading = false;
      }
    },

    async u_exportar() {
      this.u_exportLoading = true;
      try {
        const resp = await this.$store.dispatch('auth/analyticsParticipantesPorUsuarioExport', {
          ...this.u_filters,
        });
        const blob = resp?.data instanceof Blob ? resp.data : new Blob([resp.data]);
        const filename = `participantes_por_usuario_${this.hoyYMD()}.xlsx`;
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = filename;
        document.body.appendChild(a);
        a.click();
        a.remove();
        window.URL.revokeObjectURL(url);
      } catch (e) {
        console.error(e);
        this.$swal?.fire({ icon: 'error', title: 'Error', text: 'No se pudo exportar el Excel.', timer: 3000, showConfirmButton: false });
      } finally {
        this.u_exportLoading = false;
      }
    },

    async u_abrirCanales(row) {
      this.u_modal.open             = true;
      this.u_modal.loading          = true;
      this.u_modal.telegram_id      = row.telegram_id;
      this.u_modal.telegram_username = row.telegram_username;
      this.u_modal.nombre           = row.nombre;
      this.u_modal.canales          = [];
      try {
        const resp = await this.$store.dispatch('auth/analyticsParticipantesDetalle', {
          telegram_id: String(row.telegram_id),
          tipster_id:  this.u_filters.tipster_id || 0,
        });
        this.u_modal.canales = resp.canales || [];
      } catch (e) {
        console.error(e);
      } finally {
        this.u_modal.loading = false;
      }
    },

    async apiFetch(payload) {
      // ✅ store (tu patrón real)
      return await this.$store.dispatch("auth/analyticsParticipantes", payload);
    },

    async apiExport(payload) {
      // ✅ store → service → axios blob
      return await this.$store.dispatch("auth/analyticsParticipantesExport", payload);
    },


        async cargarCombos() {
      try {
        // ✅ Tipsters
        const rTip = await this.$store.dispatch("auth/listaTipsters");
        this.tipsters = rTip?.data || rTip || [];

        // Canales: carga todos en paralelo (un request por tipster, pero simultáneos)
        const results = await Promise.all(
          this.tipsters.map(t =>
            this.$store.dispatch("auth/listaCanales", { tipster_id: Number(t.id) }).catch(() => [])
          )
        );
        const all = results.flatMap(r => r?.data || r || []);

        // dedupe por id
        const map = new Map();
        for (const c of all) map.set(Number(c.id), c);
        this.canales = Array.from(map.values());
      } catch (e) {
        console.warn("No se pudieron cargar combos", e);
        this.tipsters = [];
        this.canales = [];
      }
    },

  },

  async mounted() {
    this.$store.commit('setShowFooter', true);
    await this.cargarCombos();
    await this.cargar(true);
  },
};
</script>

<style scoped>
.container-fluid { max-width: 1100px; }

/* ===== Filtros ===== */
.filter-grid { display: flex; flex-direction: column; gap: 14px; }

.filter-inputs {
  display: flex;
  gap: 12px;
  align-items: flex-end;
  flex-wrap: wrap;
}

.filter-field {
  display: flex;
  flex-direction: column;
  flex: 1 1 160px;
  min-width: 140px;
}
.filter-field--wide { flex: 1.8 1 200px; }
.filter-field--date { flex: 0 1 148px; min-width: 130px; }
.filter-field--date input[type="date"] { color-scheme: dark; }

.filter-actions {
  display: flex;
  gap: 8px;
  align-items: center;
  flex-shrink: 0;
}

.filter-bottom {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 12px;
}

.filter-checks {
  display: flex;
  gap: 20px;
  align-items: center;
  flex-wrap: wrap;
}

.filter-check-item {
  display: flex;
  align-items: center;
  gap: 7px;
  cursor: pointer;
  font-size: 0.8125rem;
  color: var(--q-muted);
  font-weight: 500;
  margin: 0;
  user-select: none;
}
.filter-check-item input[type="checkbox"] {
  width: 16px;
  height: 16px;
  flex-shrink: 0;
  cursor: pointer;
  accent-color: var(--q-gold);
}

.btn-f-buscar {
  padding: 8px 22px;
  background: var(--q-gold);
  color: #fff;
  border: none;
  border-radius: 8px;
  font-size: 0.85rem;
  font-weight: 600;
  cursor: pointer;
  white-space: nowrap;
  transition: background .15s;
}
.btn-f-buscar:hover:not(:disabled) { background: var(--q-gold-hover); }
.btn-f-buscar:disabled { opacity: .6; cursor: not-allowed; }

.btn-f-limpiar {
  padding: 8px 22px;
  background: var(--q-hover);
  color: var(--q-muted);
  border: 1.5px solid var(--q-border-md);
  border-radius: 8px;
  font-size: 0.85rem;
  font-weight: 600;
  cursor: pointer;
  white-space: nowrap;
  transition: background .15s;
}
.btn-f-limpiar:hover:not(:disabled) { background: var(--q-card-alt); }
.btn-f-limpiar:disabled { opacity: .6; cursor: not-allowed; }

.select-wrap {
  position: relative;
}
.select-wrap select {
  appearance: none !important;
  -webkit-appearance: none !important;
}
.select-wrap .form-select {
  --bs-form-select-bg-img: none !important;
  background-image: none !important;
  padding-right: 36px;
}
.select-wrap::after {
  content: "";
  position: absolute;
  right: 14px;
  top: 50%;
  transform: translateY(-25%);
  width: 0; height: 0;
  border-left: 5px solid transparent;
  border-right: 5px solid transparent;
  border-top: 6px solid var(--q-muted);
  pointer-events: none;
}

.table-listado th, .table-listado td{
  padding-top:10px; padding-bottom:10px;
}

.th-sort {
  cursor: pointer;
  user-select: none;
  white-space: nowrap;
}
.th-sort:hover { background: var(--q-hover); }
.th-sort::after,
.th-sort::before { display: none !important; content: none !important; }
.sort-icon {
  display: inline-block;
  margin-left: 4px;
  font-size: 0.625rem;
  opacity: 0.6;
  vertical-align: middle;
}

.mini-card{
  border:1px solid var(--q-border);
  background: var(--q-card-alt);
  border-radius:12px;
  padding:12px 14px;
  height: 100%;
  min-height: 80px;
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.mini-card .k{ font-size:0.75rem; opacity:.7; }
.mini-card .v{ font-size:1.125rem; font-weight:700; color: var(--q-text); }
.mini-card__v--verde { color: var(--q-green) !important; }
.mini-card__v--azul  { color: var(--q-gold) !important; }
.mini-card__sub { font-size: 0.625rem; color: var(--q-muted); margin-top: 2px; }

.totales-pill{
  display:flex;
  flex-wrap:wrap;
  gap:10px 14px;
  font-size:0.75rem;
  opacity:.85;
  background: var(--q-card-alt);
  border:1px solid var(--q-border);
  padding:10px 12px;
  border-radius:12px;
}

/* ===== Tabla empirulada ===== */
.table-empirulada {
  border-collapse: separate !important;
  border-spacing: 0 8px;
}
.table-empirulada thead th {
  border: 0 !important;
  border-radius: 0 !important;
  background: var(--q-hover);
  color: var(--q-text);
  font-weight: 700;
  padding: 10px 12px;
}
.table-empirulada tbody tr {
  background: var(--q-card);
  box-shadow: 0 4px 14px rgba(0,0,0,.05);
}
.table-empirulada tbody td {
  border: 0 !important;
  border-radius: 0 !important;
  padding: 10px 12px;
  vertical-align: middle;
}
/* Redondear solo las esquinas exteriores de cada fila */
.table-empirulada tbody tr td:first-child {
  border-radius: 8px 0 0 8px !important;
}
.table-empirulada tbody tr td:last-child {
  border-radius: 0 8px 8px 0 !important;
}
.table-empirulada > :not(caption) > * > * {
  border-bottom-width: 0 !important;
}
.table-empirulada tbody tr:hover {
  transform: translateY(-1px);
  transition: .15s ease;
}

.campana-nombre{
  font-weight: 700;
  color: var(--q-text);
  line-height: 1.15;
}
.canal-sub{
  font-size: 0.75rem;
  opacity: .75;
  line-height: 1.15;
}
.fecha-entrada {
  font-size: 0.75rem;
  font-weight: 600;
  color: var(--q-muted);
  white-space: nowrap;
}

/* Idioma — tabla */
.idioma-flag { width: 20px; height: 15px; border-radius: 2px; display: inline-block; }

/* Idioma — card lista */
.idioma-card { display: flex; flex-direction: column; }
.idioma-lista {
  padding: 10px 16px 14px;
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.idioma-row {
  display: flex;
  align-items: center;
  gap: 8px;
}
.idioma-flag-lg {
  width: 22px;
  height: 16px;
  border-radius: 2px;
  flex-shrink: 0;
}
.idioma-name {
  font-size: 0.8rem;
  color: var(--q-text);
  white-space: nowrap;
  width: 90px;
  flex-shrink: 0;
  overflow: hidden;
  text-overflow: ellipsis;
}
.idioma-bar-wrap {
  flex: 1;
  height: 6px;
  background: var(--q-hover);
  border-radius: 4px;
  overflow: hidden;
}
.idioma-bar-fill {
  height: 100%;
  background: rgba(245, 166, 35, .85);
  border-radius: 4px;
  transition: width 0.4s ease;
}
.idioma-count {
  font-size: 0.78rem;
  color: var(--q-muted);
  white-space: nowrap;
  min-width: 28px;
  text-align: right;
}

/* Estado */
.estado-pill {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  padding: 3px 10px;
  border-radius: 20px;
  font-size: 0.6875rem;
  font-weight: 700;
  white-space: nowrap;
}
.estado-activo { background: var(--q-green-soft); color: var(--q-green); }
.estado-salio  { background: var(--q-hover); color: var(--q-muted); }
.estado-dot {
  width: 6px; height: 6px;
  border-radius: 50%;
  flex-shrink: 0;
}
.estado-activo .estado-dot { background: var(--q-green); }
.estado-salio  .estado-dot { background: var(--q-muted); }

/* Reingresos */
.reingreso-badge {
  display: inline-block;
  background: var(--q-amber-soft);
  color: var(--q-amber);
  font-size: 0.6875rem;
  font-weight: 700;
  padding: 2px 8px;
  border-radius: 20px;
}

/* Compras */
.compras-badge {
  display: inline-block;
  background: var(--q-green-soft);
  color: var(--q-green);
  font-size: 0.6875rem;
  font-weight: 700;
  padding: 2px 8px;
  border-radius: 20px;
}

/* Gasto */
.gasto-valor {
  font-weight: 700;
  color: var(--q-gold);
}

/* Franja */
.franja-badge {
  display: inline-block;
  font-size: 0.6875rem;
  font-weight: 600;
  padding: 3px 9px;
  border-radius: 20px;
  white-space: nowrap;
}
.franja-mañana { background: var(--q-amber-soft); color: var(--q-amber); }
.franja-tarde  { background: var(--q-amber-soft); color: var(--q-amber); }
.franja-noche  { background: var(--q-hover); color: var(--q-text); }

/* Vacío */
.celda-vacia { color: var(--q-muted); font-size: 0.8125rem; }

/* paginación */
.pagi-row{
  display:flex;
  gap:10px;
  align-items:center;
  margin-top: 16px;
  flex-wrap: wrap;
}
.pagi-info{
  padding: 8px 10px;
  background: var(--q-card-alt);
  border:1px solid var(--q-border);
  border-radius:12px;
}
.pagi-row .btn-secondary {
  background: var(--q-card-alt);
  border: 1px solid var(--q-border-md);
  color: var(--q-text-muted);
  font-size: 0.9rem;
  line-height: 1;
  padding: 5px 10px;
  transition: background .15s, color .15s;
}
.pagi-row .btn-secondary:hover:not(:disabled) {
  background: var(--q-hover);
  color: var(--q-gold);
  border-color: var(--q-gold);
}
.pagi-row .btn-secondary:disabled { opacity: .4; cursor: not-allowed; }

/* Botón Excel */
.btn-excel {
  display: inline-flex; align-items: center; gap: 6px;
  padding: 6px 14px; border-radius: 8px; border: none; cursor: pointer;
  background: var(--q-green-soft); color: var(--q-green); font-size: 0.75rem; font-weight: 700;
  transition: .15s;
}
.btn-excel:hover:not(:disabled) { background: var(--q-green); color: #fff; }
.btn-excel:disabled { opacity: .5; cursor: not-allowed; }
.btn-actualizar-nicks {
  display: inline-flex; align-items: center; gap: 6px;
  padding: 6px 14px; border-radius: 8px; cursor: pointer; font-size: 0.75rem; font-weight: 700;
  border: 1px solid rgba(41,182,246,.4); background: rgba(41,182,246,.1); color: #29b6f6;
  transition: .15s;
}
.btn-actualizar-nicks:hover:not(:disabled) { background: rgba(41,182,246,.25); border-color: #29b6f6; }
.btn-actualizar-nicks:disabled { opacity: .5; cursor: not-allowed; }
.detalle-username { color: #4caf50; font-weight: 600; font-size: 0.82rem; }

/* Barra gasto */
.gasto-bar-row { display: flex; align-items: center; gap: 6px; min-width: 110px; }
.gasto-bar-track {
  flex: 1; height: 6px; background: var(--q-border);
  border-radius: 6px; overflow: hidden;
}
.gasto-bar-fill {
  height: 100%; border-radius: 6px;
  background: linear-gradient(90deg, #43a047, #66bb6a);
  transition: width .4s ease;
}

/* Leyenda badges */
.leyenda-badges {
  display: flex; align-items: center; flex-wrap: wrap; gap: 6px;
  padding: 8px 4px; margin-bottom: 8px;
}
.leyenda-title {
  font-size: 0.625rem; font-weight: 700; text-transform: uppercase;
  color: var(--q-muted); letter-spacing: .05em; margin-right: 4px;
}
.leyenda-desc {
  font-size: 0.625rem; color: var(--q-muted); margin-right: 8px;
}

/* Badges de perfil */
.perfil-badge {
  display: inline-block; font-size: 0.5625rem; font-weight: 800;
  padding: 1px 6px; border-radius: 20px; margin-left: 6px;
  text-transform: uppercase; letter-spacing: .04em; vertical-align: middle;
}
.perfil-vip         { background: var(--q-amber-soft); color: var(--q-amber); border: 1px solid var(--q-border); }
.perfil-reincidente { background: var(--q-red-soft); color: var(--q-red); border: 1px solid var(--q-border); }
.perfil-comprador   { background: var(--q-green-soft); color: var(--q-green); border: 1px solid var(--q-border); }
.perfil-fugaz       { background: var(--q-hover); color: var(--q-muted); border: 1px solid var(--q-border); }
.perfil-activo      { background: var(--q-hover); color: var(--q-gold); border: 1px solid var(--q-border); }

/* Botón detalle en fila */
.btn-detalle {
  display: inline-flex; align-items: center; justify-content: center;
  width: 28px; height: 28px; border-radius: 8px; border: none;
  background: var(--q-hover); color: var(--q-gold); cursor: pointer; transition: .15s;
}
.btn-detalle:hover { background: var(--q-gold); color: var(--q-gold-on); }

/* Modal overlay */
.det-overlay {
  position: fixed; inset: 0; z-index: 9999;
  background: rgba(30, 40, 60, 0.45);
  display: flex; align-items: center; justify-content: center;
  padding: 16px;
}
.det-panel {
  background: var(--q-card); border-radius: 16px;
  width: 100%; max-width: 680px; max-height: 85vh;
  display: flex; flex-direction: column;
  box-shadow: 0 20px 60px rgba(0,0,0,.18);
  overflow: hidden;
}
.det-header {
  display: flex; align-items: flex-start; justify-content: space-between;
  padding: 20px 24px 20px;
  background: linear-gradient(120deg, var(--q-card-alt) 0%, var(--q-card) 100%);
  flex-shrink: 0;
}
.det-nombre { font-size: 0.9375rem; font-weight: 800; color: var(--q-text); }
.det-sub { font-size: 0.6875rem; color: var(--q-muted); margin-top: 3px; }
.det-close {
  background: rgba(255,255,255,.2); border: none; border-radius: 8px;
  width: 32px; height: 32px; cursor: pointer; font-size: 0.875rem;
  color: var(--q-text); flex-shrink: 0; transition: .15s;
  display: flex; align-items: center; justify-content: center;
}
.det-close:hover { background: rgba(0,0,0,.2); }

.det-body {
  overflow-y: auto; overflow-x: auto; padding: 20px 24px; flex: 1;
  display: flex; flex-direction: column; gap: 24px;
  background: var(--q-bg);
}

.det-loading {
  display: flex; align-items: center; justify-content: center;
  gap: 10px; padding: 40px; color: var(--q-muted); font-size: 0.8125rem;
}
.det-spinner {
  width: 20px; height: 20px; border-radius: 50%;
  border: 3px solid var(--q-border); border-top-color: var(--q-gold);
  animation: spin .7s linear infinite; display: inline-block;
}
@keyframes spin { to { transform: rotate(360deg); } }

.det-section {
  background: var(--q-card-alt); border-radius: 12px;
  padding: 16px 18px; box-shadow: 0 1px 4px rgba(0,0,0,.06);
}

.det-section-title {
  font-size: 0.6875rem; font-weight: 700; text-transform: uppercase;
  color: var(--q-muted); letter-spacing: .05em; margin-bottom: 10px;
  display: flex; align-items: center; gap: 8px;
}
.det-badge {
  background: var(--q-hover); color: var(--q-gold); border-radius: 20px;
  font-size: 0.625rem; font-weight: 800; padding: 1px 7px;
  text-transform: none; letter-spacing: 0;
}
.det-empty { font-size: 0.75rem; color: var(--q-muted); }

/* Tabla canales */
.det-table { width: 100%; font-size: 0.75rem; border-collapse: collapse; border: none !important; }
.det-table thead { border: none !important; }
.det-table th {
  font-size: 0.625rem; text-transform: uppercase; color: var(--q-muted);
  font-weight: 600; padding: 4px 8px;
  background: transparent !important; box-shadow: none !important;
  border: none !important; border-bottom: 1px solid var(--q-border) !important;
}
.det-table td {
  padding: 8px 8px;
  vertical-align: middle; border-radius: 0 !important;
  box-shadow: none !important; background: transparent !important;
  border: none !important; border-bottom: 1px solid var(--q-border) !important;
}
.det-table tr:last-child td { border-bottom: none !important; }

/* Timeline compras */
.det-timeline { display: flex; flex-direction: column; }
.det-tl-item {
  display: flex; gap: 12px; position: relative; padding-bottom: 16px;
}
.det-tl-item:last-child { padding-bottom: 0; }
.det-tl-dot {
  width: 10px; height: 10px; border-radius: 50%; background: var(--q-gold);
  flex-shrink: 0; margin-top: 3px; position: relative; z-index: 1;
}
.det-tl-line {
  position: absolute; left: 4px; top: 13px; bottom: 0;
  width: 2px; background: var(--q-border);
}
.det-tl-content { flex: 1; }
.det-tl-fecha { font-size: 0.6875rem; color: var(--q-muted); margin-bottom: 3px; }
.det-tl-info { display: flex; align-items: center; gap: 8px; flex-wrap: wrap; }
.det-tl-canal { font-size: 0.75rem; font-weight: 700; color: var(--q-text); }
.det-tl-precio { font-size: 0.8125rem; font-weight: 800; color: var(--q-green); }
.det-tl-tipo {
  font-size: 0.625rem; background: var(--q-hover); color: var(--q-muted);
  border-radius: 6px; padding: 2px 7px; font-weight: 600;
}

/* Transición */
.modal-fade-enter-active, .modal-fade-leave-active { transition: opacity .2s; }
.modal-fade-enter-from, .modal-fade-leave-to { opacity: 0; }

/* ===== Gráficos ===== */
.graficos-row {
  display: flex;
  gap: 24px;
  align-items: stretch;
  flex-wrap: wrap;
}
.grafico-bloque {
  display: flex;
  flex-direction: column;
}
.grafico-bloque--donut {
  background: var(--q-card-alt);
  border: 1px solid var(--q-border);
  border-radius: 12px;
  padding: 16px;
  flex: 0 0 200px;
  align-items: center;
}
.grafico-bloque--bar {
  flex: 1 1 240px;
  /* sin background ni borde — QuantyBarChart tiene su propio q-chart-card */
}
.grafico-titulo {
  font-size: 0.625rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.07em;
  color: var(--q-muted);
  margin-bottom: 12px;
  align-self: flex-start;
}
.grafico-donut-inner {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  width: 100%;
}
.donut-leyenda {
  display: flex;
  flex-direction: column;
  gap: 6px;
  width: 100%;
}
.donut-ley-item {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 0.75rem;
}
.donut-ley-item span:nth-child(2) { flex: 1; color: var(--q-muted); }
.donut-ley-item b { color: var(--q-text); font-weight: 700; }
.donut-ley-dot {
  width: 10px; height: 10px;
  border-radius: 50%;
  flex-shrink: 0;
}

/* Responsive gráficos */
@media (max-width: 768px) {
  .grafico-bloque--donut { flex: 0 0 100%; }
  .grafico-bloque--bar   { flex: 0 0 100%; min-height: 160px; }
}

/* ===== Chip de sección ===== */
.seccion-chip {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 0.625rem;
  font-weight: 800;
  text-transform: uppercase;
  letter-spacing: 0.09em;
  color: var(--q-gold);
  background: var(--q-card-alt);
  border: 1px solid var(--q-border-md);
  padding: 4px 12px;
  border-radius: 20px;
}

/* ===== Separador de sección ===== */
.seccion-sep {
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 4px 0;
}
.seccion-sep__rail {
  flex: 1;
  height: 1px;
  background: var(--q-border);
}
.seccion-sep__label {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 0.6875rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  color: var(--q-muted);
  background: var(--q-card-alt);
  border: 1px solid var(--q-border-md);
  padding: 6px 16px;
  border-radius: 20px;
  white-space: nowrap;
}

/* ===== Canal count badge (sección 2) ===== */
.canal-count-badge {
  display: inline-block;
  background: rgba(41, 182, 246, 0.12);
  color: #29b6f6;
  font-size: 0.6875rem;
  font-weight: 700;
  padding: 2px 8px;
  border-radius: 20px;
}

/* ===== Multicanal tag ===== */
.multicanal-tag {
  display: inline-block;
  background: rgba(149, 117, 205, 0.15);
  color: #9575cd;
  font-size: 0.5rem;
  font-weight: 800;
  padding: 2px 6px;
  border-radius: 20px;
  text-transform: uppercase;
  letter-spacing: 0.05em;
}
</style>
